import React, {Component} from 'react';
import {Button, Icon, Message} from 'semantic-ui-react';
import ReactTable from "react-table";
import Loader from '../../universal/loader';
import {EXPENSE} from "../../../constants/app_routes";
import AccountExpenseContainer from "../../../containers/account_expense_container";
import {withRouter} from 'react-router-dom';

class ExpenseEstimates extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalEstimate: 0,
            filterApplied: false,
            selectedIds: [],
            isApproving: false
        }
    }

    componentWillMount() {
        this.props.getExpenseEstimates();
    }

    handleView = (id) => {
        this.props.history.push(`${EXPENSE}/pipeline/view/${id}`);
    };

    calculateSum = () => {
        if (this.selectTable) {
            const filteredData = this.selectTable.getResolvedState().sortedData;
            let totalEstimates = 0;
            if (filteredData) {
                for (let i = 0; i < filteredData.length; i++) {
                    totalEstimates += parseInt(filteredData[i]['total_amount'],10);
                }
                this.setState({totalEstimate: totalEstimates, filterApplied: true});
            }
        }
    };

    calculateInitialSum = () => {
        const estimates = this.props.estimates;
        let totalEstimates = 0;

        if (estimates && estimates.length > 0) {

            for (let i = 0; i < estimates.length; i++) {
                totalEstimates += parseInt(estimates[i]['total_amount'], 10);
            }
            return totalEstimates;
        }
        return 0;
    };

    handleSelection = (id) => {
        let selectedId = this.state.selectedIds;
        const index = selectedId.indexOf(id);
        if (index === -1) {
            selectedId.push(id);
        }
        else {
            selectedId.splice(index, 1)
        }
        this.setState({selectedIds: selectedId});
    };

    handleBulkApprove = () => {
        this.setState({isApproving: true});
        const formData = {
            pipeline_expense_ids: this.state.selectedIds,
            status: '1'
        };
        this.props.approveSelectedExpenses(formData, this.successCallBack)
    };

    successCallBack = (response) => {
        if (response.success) {
            this.setState({selectedIds: [], isApproving: false, expenseSubmitted: true})
        }
        else {
            this.setState({error: true})
        }
    };

    render() {

        const columns = [{
            Header: 'Select',
            id: 'selection',
            accessor: 'id',
            headerClassName: 'micro-width',
            className: 'center-aligned micro-width',
            filterable: false,
            Cell: ({value}) => (
                <div>
                    <input type="checkbox" onClick={(e) => {
                        this.handleSelection(value)
                    }}/>
                </div>
            ),
        }, {
            Header: 'Date',
            accessor: 'date',
            className: 'center-aligned',
            filterable: true,
        }, {
            Header: 'Reference Id',
            accessor: 'agent_reference_id',
            className: 'center-aligned',
            filterable: true
        }, {
            Header: 'Clerk Name',
            accessor: 'clerk_profile_name',
            className: 'max-width',
            headerClassName: 'max-width',
            filterable: true
        }, {
            Header: 'Job Type',
            headerClassName: 'mini-width',
            accessor: 'inspection_type',
            className: 'formatcase mini-width',
            filterable: true,
        }, {
            Header: 'AEC',
            accessor: 'aec',
            headerClassName: 'mini-width',
            className: 'mini-width',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        }, {
            Header: 'Train',
            accessor: 'train',
            headerClassName: 'mini-width',
            className: 'mini-width',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        }, {
            Header: 'Park',
            accessor: 'parking',
            headerClassName: 'mini-width',
            className: 'mini-width',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        }, {
            Header: 'Fuel',
            accessor: 'fuel',
            headerClassName: 'mini-width',
            className: 'mini-width',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        }, {
            Header: 'Total',
            accessor: 'total_amount',
            className: 'format-bold',
            filterable: true,
            Cell: ({value}) => (
                <div>
                    <span>£ {value}</span>
                </div>
            ),
        }, {
            Header: 'Expense Status',
            className: 'center-aligned',
            accessor: 'status',
            Cell: ({value}) => (
                <div>
                    <Button size='mini' fluid><span className="format-capitalize">{value}</span></Button>
                </div>
            ),
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            headerClassName: 'mini-width',
            className: 'center-aligned mini-width',
            accessor: 'id',
            sortable:false,
            Cell: ({value}) => (
                <div>
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                </div>
            )
        }];
        return (<div style={{minHeight: '550px'}} className="pad-bottom">
            <div style={{position: 'absolute', top: '-15%', right: '0'}}>
                {this.state.expenseSubmitted &&<Message positive onDismiss={() => {
                    this.setState({selectedIds: [], expenseSubmitted: false})
                }}>
                    <Message.Header>Expenses Successfully Approved </Message.Header></Message>}
            </div>
            <div className="pad-bottom right-aligned">
                <span> Selected Items : </span><span
                className="format-bold"> {this.state.selectedIds.length}</span><span className="pad-left">
                <Button content="Approve Selected" disabled={this.state.isApproving} primary
                        onClick={this.handleBulkApprove}/>
            </span>
            </div>
            {!this.props.isFetching && <ReactTable
                data={this.props.estimates}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                minRows={11}
                showPagination={false}
                style={{
                    height: '550px'
                }}
                noDataText="No Expense Estimates found"
            />}
            {this.props.isFetching && <Loader/>}
        </div>)
    }
}

export default AccountExpenseContainer(withRouter(ExpenseEstimates));


// WEBPACK FOOTER //
// ./src/views/accounts/expense/expense_estimate.js